module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"browseProducts":"BROWSE PRODUCTS"},"lng_zh":{"browseProducts":"浏览产品"},"lng_th":{"browseProducts":"เรียกดูผลิตภัณฑ์"},"lng_id":{"browseProducts":"TELUSURI PRODUK"},"lng_ko":{"browseProducts":"제품 찾아보기"}}')
  delete Component.options._Ctor
}
